<app-side-menu>
  <div class="preventive-maintenance-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="vehicleTypeFilter" class="form-label">Filtrar por Tipo de Veículo:</label>
          <select
            id="vehicleTypeFilter"
            class="form-select"
            [(ngModel)]="filters.vehicleType"
            (change)="applyFilters()">
            <option value="">Todos os tipos</option>
            <option *ngFor="let type of vehicleTypes" [value]="type">
              {{ type }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select
            id="statusFilter"
            class="form-select"
            [(ngModel)]="filters.isActive"
            (change)="applyFilters()">
            <option value="">Todos os Status</option>
            <option value="true">Apenas Ativas</option>
            <option value="false">Apenas Inativas</option>
          </select>
        </div>

        <div class="filter-actions">
          <button
            type="button"
            class="btn btn-outline-secondary me-2"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
          <button
            *appHasPermission="'PreventiveMaintenance.Create'"
            type="button"
            class="btn btn-primary"
            (click)="createPreventiveMaintenance()">
            <i class="fas fa-plus me-2"></i>
            Nova Preventiva
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Preventivas -->
    <div *ngIf="!isLoading && !error && filteredPreventiveMaintenances.length > 0">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="filteredPreventiveMaintenances"
        [loading]="isLoading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [enableSorting]="true"
        (sortChange)="onSortChange($event)"
        (actionClick)="onActionClick($event)">
      </app-table>
    </div>

    <!-- Estado Vazio Simples -->
    <div *ngIf="!isLoading && !error && filteredPreventiveMaintenances.length === 0" class="empty-state-simple">
      <div class="empty-message">
        <i class="fas fa-tools"></i>
        <p>Nenhuma preventiva encontrada</p>
      </div>
    </div>

<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

  </div>
</app-side-menu>



